// Small inline stroke icons for icon-only buttons. Static, trusted markup
// only (never user content) — no external icon font/CDN (privacy rule,
// ADR-0002). All icons inherit color via currentColor so they follow the
// button's text color, including dark mode.
function icon(paths: string): HTMLElement {
  const span = document.createElement('span');
  span.className = 'icon';
  span.setAttribute('aria-hidden', 'true');
  span.innerHTML = `<svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  return span;
}

export const icons = {
  // Won't do: a plain X.
  wontDo: (): HTMLElement => icon('<path d="M5 5l10 10M15 5L5 15"/>'),
  // Not needed: a "prohibited" circle-with-slash, in the app's neutral ink
  // color rather than traffic-sign red — it isn't a warning, just "skip".
  notNeeded: (): HTMLElement => icon('<circle cx="10" cy="10" r="7.3"/><path d="M4.8 4.8l10.4 10.4"/>'),
  // Done: a checkmark.
  done: (): HTMLElement => icon('<path d="M4.5 10.3l3.7 3.7 7.3-8.6"/>'),
  // Done-then-choose (shared display, ADR-0049): a checkmark plus a trailing
  // ellipsis — the standard "opens a further step" hint, so it reads as
  // "done → pick who", not "completes instantly".
  doneMore: (): HTMLElement =>
    icon(
      '<path d="M2 10.4l2.9 2.9 5.3-6.3"/>' +
        '<circle cx="13.4" cy="13" r="1.05" fill="currentColor" stroke="none"/>' +
        '<circle cx="16" cy="13" r="1.05" fill="currentColor" stroke="none"/>' +
        '<circle cx="18.6" cy="13" r="1.05" fill="currentColor" stroke="none"/>',
    ),
  // Group (eligibility group / "kids", "parents"): a two-person glyph.
  group: (): HTMLElement =>
    icon(
      '<circle cx="7" cy="7.2" r="2.5"/>' +
        '<path d="M2.5 15.2c0-2.5 2-4.1 4.5-4.1s4.5 1.6 4.5 4.1"/>' +
        '<circle cx="14.2" cy="8" r="1.9"/>' +
        '<path d="M13 11.3c2.2-.1 4 1.3 4 3.6"/>',
    ),
  // Label / category tag: a luggage-tag shape.
  tag: (): HTMLElement =>
    icon('<path d="M10.5 3H3v7.5l7 7 7.5-7.5-7-7z"/><circle cx="6.4" cy="6.4" r="1.1" fill="currentColor" stroke="none"/>'),
  // Add: a plus. The floating action button's glyph.
  plus: (): HTMLElement => icon('<path d="M10 4.2v11.6M4.2 10h11.6"/>'),
  // Hamburger: the nav drawer trigger (ADR-0051).
  menu: (): HTMLElement => icon('<path d="M3.5 6h13M3.5 10h13M3.5 14h13"/>'),
  // Shared display (ADR-0049): a tablet/device outline — the picker card for
  // the family's shared device, which is a device, not a person.
  display: (): HTMLElement =>
    icon('<rect x="3.2" y="3.5" width="13.6" height="13" rx="1.8"/><path d="M8.4 16.5h3.2"/>'),
  // Close / dismiss a sheet.
  close: (): HTMLElement => icon('<path d="M5 5l10 10M15 5L5 15"/>'),
  // Disclosure chevron, pointing down: marks a control that opens a menu.
  chevronDown: (): HTMLElement => icon('<path d="M5 8l5 5 5-5"/>'),
  // More options: a vertical kebab (three dots).
  more: (): HTMLElement =>
    icon(
      '<circle cx="10" cy="4.5" r="1.3" fill="currentColor" stroke="none"/>' +
        '<circle cx="10" cy="10" r="1.3" fill="currentColor" stroke="none"/>' +
        '<circle cx="10" cy="15.5" r="1.3" fill="currentColor" stroke="none"/>',
    ),
};
